import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, IconButton, Typography, Box, Chip, Divider, Tooltip
} from '@mui/material'
import VisibilityIcon from '@mui/icons-material/Visibility'
import CloseIcon from '@mui/icons-material/Close'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { useState } from 'react'

export default function ViewBlogModal({ blog }) {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Tooltip title="View">
        <IconButton
          size="small"
          onClick={() => setOpen(true)}
          sx={{ color: '#1A73E8', '&:hover': { backgroundColor: '#e8f0fe' } }}
        >
          <VisibilityIcon fontSize="small" />
        </IconButton>
      </Tooltip>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth
        PaperProps={{ sx: { borderRadius: '16px' } }}>

        <DialogTitle sx={{
          background: 'linear-gradient(135deg, #1A73E8 0%, #0D47A1 100%)',
          color: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          py: 2, px: 3,
        }}>
          <Typography variant="h6" fontWeight={700} style={{color:"white"}} fontSize="1rem">Blog Preview</Typography>
          <IconButton onClick={() => setOpen(false)} sx={{ color: 'white' }} size="small">
            <CloseIcon style={{color:"white"}} />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ px: 4, py: 3 }}>
          {/* Meta Info */}
          <Box display="flex" alignItems="center" gap={1} mb={2} flexWrap="wrap">
            <Chip
              label={blog.status === 'published' ? 'Published' : 'Draft'}
              size="small"
              sx={{
                backgroundColor: blog.status === 'published' ? '#e8f5e9' : '#fff3e0',
                color: blog.status === 'published' ? '#2e7d32' : '#e65100',
                fontWeight: 600, border: `1px solid ${blog.status === 'published' ? '#a5d6a7' : '#ffcc80'}`,
              }}
            />
            <Typography variant="caption" color="text.secondary">
              {blog.author} · {blog.publishedDate
                ? new Date(blog.publishedDate).toLocaleDateString('en-AU', { day: '2-digit', month: 'long', year: 'numeric' })
                : 'No date'}
            </Typography>
          </Box>

          <Typography variant="h5" fontWeight={700} mb={1}>{blog.title}</Typography>

          <Box display="flex" gap={1} mb={2} flexWrap="wrap">
            <Box sx={{ backgroundColor: '#f5f5f5', borderRadius: '6px', px: 1.5, py: 0.5 }}>
              <Typography variant="caption" color="text.secondary">
                <b>Slug:</b> {blog.slug}
              </Typography>
            </Box>
            {blog.canonicalUrl && (
              <Box sx={{ backgroundColor: '#f5f5f5', borderRadius: '6px', px: 1.5, py: 0.5 }}>
                <Typography variant="caption" color="text.secondary">
                  <b>URL:</b> {blog.canonicalUrl}
                </Typography>
              </Box>
            )}
          </Box>

          {blog.metaDescription && (
            <Box sx={{ backgroundColor: '#e8f0fe', borderRadius: '8px', p: 2, mb: 2 }}>
              <Typography variant="caption" fontWeight={700} color="#1A73E8">META DESCRIPTION</Typography>
              <Typography variant="body2" mt={0.5}>{blog.metaDescription}</Typography>
            </Box>
          )}

          <Divider sx={{ my: 2 }} />

          {/* Blog Body rendered as HTML */}
          <Box

            dangerouslySetInnerHTML={{ __html: blog.body }}
          />
        </DialogContent>

        <DialogActions sx={{ px: 4, pb: 3 }}>
          {/* {blog.canonicalUrl && (
            <Button
              variant="outlined"
              endIcon={<OpenInNewIcon />}
              href={blog.canonicalUrl}
              target="_blank"
              sx={{ borderRadius: '8px', textTransform: 'none' }}
            >
              View Live
            </Button>
          )} */}
          <Button onClick={() => setOpen(false)} variant="contained"
            style={{ color: "white" }}
            sx={{ borderRadius: '8px', textTransform: 'none', background: 'linear-gradient(135deg, #1A73E8, #0D47A1)' }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
